"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMediaBuffering = void 0;
const react_1 = require("react");
const use_buffer_state_1 = require("./use-buffer-state");
const useMediaBuffering = (element, shouldBuffer) => {
    const buffer = (0, use_buffer_state_1.useBufferState)();
    (0, react_1.useEffect)(() => {
        let cleanup = () => undefined;
        const { current } = element;
        if (!current) {
            return;
        }
        if (!shouldBuffer) {
            return;
        }
        const onWaiting = () => {
            const { unblock } = buffer.delayPlayback();
            const onCanPlay = () => {
                unblock();
            };
            current.addEventListener('canplay', onCanPlay, {
                once: true,
            });
            cleanup = () => {
                current.removeEventListener('canplay', onCanPlay);
                unblock();
                return undefined;
            };
        };
        if (current.readyState < current.HAVE_FUTURE_DATA) {
            onWaiting();
        }
        else {
            current.addEventListener('waiting', onWaiting);
        }
        return () => {
            cleanup();
        };
    }, [buffer, element, shouldBuffer]);
};
exports.useMediaBuffering = useMediaBuffering;
